import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';

class DeviceWideTaskResultIssuesAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'deviceWideTaskResultIssues';

	getCves(scanid) {
		let request = {
			url: [this.getAPIUrl(), 'scan', scanid, 'cves'].join('/'),
		};

		return httpClient.getAsync(request);
	}
}

export default new DeviceWideTaskResultIssuesAPI();
